/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { Link } from "react-router";
import utils from "@utils";
import { JURISDICTION_FEE_TYPES, NON_RK_PAY_FEE_TYPES, JOB_INVOICED_TYPES, V3_INVOICE_TYPE_ID } from "@constants";
import { useDisputeContext } from "../../../context/DisputeContext";
import TrashIcon from "../../../../../../images/trash-icon.svg";
import TimeHoverTooltip from "../TimeHoverTooltip";

const NonRKPayInvoiceItemForm = ({
	user,
	user: { TimeZoneId },
	item,
	nonRKPayInvoiceDetailHook,
	getDisputeReasonsByJobId,
	officerMiscFeesV3
}) => {
	const { lang } = global;

	const {
		invoiceState,
		openDeleteJobConfirmation,
		isLineItemTimeCardEditable,
		onClickEditInvoiceLineItemTimeCard,
		onClickViewJobActivityLogLineItem,
		handlePositionChange,
		handlePositionChangedOnBlur,
		loadingInvoiceTotals,
		isFirstItemForJob,
		isAnyLineItemFinalizedForJobEvent,
		isAttachmentsVisible,
		isTimeCardNoteVisible,
		toggleLineFees,
		deletePositionFee,
		handlePositionFeeChange,
		handlePositionFeeChangedOnBlur,
		handleNewFeeChange,
		feeTypes,
		addNewLineFee,
		clearNewLineFeeName,
		toggleAttachmentsModal,
		toggleTimeCardNotesModal,
		toggleNewLineFee,
		handleShowDeleteChange,
		handleAddFeeClick
	} = nonRKPayInvoiceDetailHook;

	const {
		finalized,
		lineFeeToggler,
		newLineFeeToggler,
	} = invoiceState;

	const shouldIncludeMiscPersonnelFee = (feeType) => {
		if (feeType.Id !== NON_RK_PAY_FEE_TYPES.MISC_PERSONNEL_FEE) {
			return true;
		}

		return (
			officerMiscFeesV3 &&
			item.JobEventInvoicedTypeId === JOB_INVOICED_TYPES.OFFICER_INVOICING &&
			invoiceState.typeId === V3_INVOICE_TYPE_ID.OFFICER
		);
  	}

	const {
		registerCardRef,
		openDisputeReason,
	} = useDisputeContext()

	const disputeReasons = getDisputeReasonsByJobId(item.JobId);
	const disputeReason = disputeReasons?.find(({ Id }) => Id === openDisputeReason)
	const isDisputed = !!disputeReason;
	const buttonClass = classNames(
		"btn", {
		"btn-link": !isDisputed,
		"btn-link-danger": isDisputed,
	});
	const textClass = classNames({
		"text-danger": isDisputed,
	})
	const inputContainerClass = classNames("col-xs-6 col-md-1 form-group", {
		"invalid-field": isDisputed,
	});
	const buttonPaddingLeft0Class = classNames("padding-left-0", buttonClass);

	return (
		<div
			ref={(ref) => {
				if (ref && disputeReason) registerCardRef(disputeReason.Id, ref)
			}}
			className={classNames("row line-item", {
				"cursor-pointer": isDisputed,
			})}
			key={`assignment_${item.JobAssignmentId}`}
			onMouseEnter={() => handleShowDeleteChange(item.JobEventId)}
			onMouseLeave={() => handleShowDeleteChange("")}
		>
			<div className="col-md-1">
				<strong className="hidden-md hidden-lg">
					{lang.t("Job ID")}:{" "}
				</strong>
				<Link to={`/jobs/${item.JobEventId}`}>
					<span className={classNames("print-padding-left-0", buttonClass)}>
						{item.JobEventId}
					</span>
				</Link>
				<If condition={isFirstItemForJob(item) && !isAnyLineItemFinalizedForJobEvent(item)}>
					<button
						type="button"
						className={classNames(
							"btn btn-link text-center delete-job-dt",
						)}
						onClick={() =>
							openDeleteJobConfirmation(item.JobEventId)
						}
					>
						<img
							className="hidden-md hidden-lg"
							src={TrashIcon}
							width="15"
							height="15"
							alt="Remove Job"
							aria-label="Remove Job"
						/>
						<img
							className="trash-icon hidden-xs hidden-sm"
							src={TrashIcon}
							width="20"
							height="20"
							alt="Remove Job"
							aria-label="Remove Job"
						/>
					</button>
				</If>

			</div>
			<div
				className="col-xs-12 col-md-2"
				title={item.JobEventTitle}
			>
				<strong className="hidden-md hidden-lg">
					{lang.t("Job Name")}:{" "}
				</strong>
				<span className="hidden-md hidden-lg">
					<Link
						to={`/jobs/${item.JobEventId}`}
					>
						<span className={textClass}>
							{`${item.JobEventTitle} (${item.JobEventId})`}
						</span>
					</Link>
				</span>
				<strong className="hidden-xs hidden-sm">
					<Link
						to={`/jobs/${item.JobEventId}`}
					>
						<span className={textClass}>
							{`${item.JobEventTitle} (${item.JobEventId})`}
						</span>
					</Link>
				</strong>
				<em className="hidden-md hidden-lg padding-left-4">
					<small>{item.JobTitle}</small>
				</em>
				<br className="hidden-xs hidden-sm" />
				<em className="hidden-xs hidden-sm">{item.JobTitle}</em>
			</div>
			<div className="col-xs-12 col-md-2 date-col">
				<div className="card-only v-align">
					<strong>
						{lang.t("Date")} &amp; {lang.t("Time")}:{" "}
					</strong>
					<span className={classNames("padding-right-4 padding-left-4", textClass)}>
						{
							utils.splitDateTimeComponents(
								item.JobStartTime,
								TimeZoneId,
								user.UserPreferences === "useMilitaryTime",
							).date
						}
					</span>
					<TimeHoverTooltip
						item={item}
						TimeZoneId={TimeZoneId}
						user={user}
						disputed={isDisputed}
					/>
				</div>
				<div className="hidden-xs hidden-sm">
					<p className={classNames("padding-right-4", textClass)}>
						{
							utils.splitDateTimeComponents(
								item.JobStartTime,
								TimeZoneId,
								user.UserPreferences === "useMilitaryTime",
							).date
						}
					</p>
					<TimeHoverTooltip
						item={item}
						TimeZoneId={TimeZoneId}
						user={user}
						disputed={isDisputed}
					/>
				</div>
				{isLineItemTimeCardEditable(item) && (
					<button
						type="button"
						className={buttonPaddingLeft0Class}
						onClick={onClickEditInvoiceLineItemTimeCard(item)}
					>
						<i className="rkf rkf-Timecard" />
						<span className="margin-left-2">
							{lang.t("Timecard")}
						</span>
					</button>
				)}
			</div>
			<div className="col-xs-12 col-md-2">
				<div
					className="align-center-sm"
					title={item.OfficerName}
					key={`position_${item.JobAssignmentId}-${item.OfficerName}`}
				>
					<strong className="card-only">{lang.t("Officer")}: </strong>
					<span className={classNames("item-officer-name", textClass)}>
						{item.OfficerName}
					</span>
					<If condition={item.OfficerId}>
						<button
							type="button"
							className={buttonPaddingLeft0Class}
							onClick={onClickViewJobActivityLogLineItem(item)}
						>
							<span className="truncate">
								{`#${item.PONumber ? item.PONumber : ""}`}
							</span>{" "}
							View Activity
						</button>
					</If>
					<If condition={isAttachmentsVisible(item)}>
						<button
							type="button"
							className={buttonPaddingLeft0Class}
							onClick={() => toggleAttachmentsModal({ ...item })}
						>
							<i
								className="rkf rkf-Paperclip"
								aria-label="View Attachments"
							/>
						</button>
					</If>
					<If condition={isTimeCardNoteVisible(item)}>
						<button
							type="button"
							className="btn btn-link padding-left-0"
							onClick={() => toggleTimeCardNotesModal({ ...item })}
						>
							<i
								className="rkf rkf-clipboard"
								aria-label="View Timecard Notes"
							/>
						</button>
					</If>
				</div>
			</div>
			<div className={classNames(inputContainerClass, "div-rate-number-padding")}>
				<label
					className="card-only"
					htmlFor={`positionRate-${item.JobAssignmentId}`}
				>
					<strong>{`${lang.t("Rate")} ($)`}</strong>
				</label>
				<input
					type="number"
					inputMode="decimal"
					id={`positionRate-${item.JobAssignmentId}`}
					name={`positionRate-${item.JobAssignmentId}`}
					className="form-control"
					value={item.Rate}
					onChange={handlePositionChange(
						item.JobAssignmentId,
						"Rate",
					)}
					disabled={loadingInvoiceTotals}
					onBlur={() =>
						handlePositionChangedOnBlur(item.JobAssignmentId)
					}
				/>
				<div className="visible-print-block">
					{utils.currencyFormatter(item.Rate)}
				</div>
			</div>
			<div className={classNames(inputContainerClass, "div-hours-number-padding")}>
				<label
					className="card-only"
					htmlFor={`positionHours-${item.JobAssignmentId}`}
				>
					<strong>{lang.t("Hours")}</strong>
				</label>
				<input
					type="number"
					id={`positionHours-${item.JobAssignmentId}`}
					name={`positionHours-${item.JobAssignmentId}`}
					className="form-control"
					value={item.Hours}
					onChange={handlePositionChange(
						item.JobAssignmentId,
						"Hours",
					)}
					disabled={loadingInvoiceTotals}
					onBlur={() =>
						handlePositionChangedOnBlur(item.JobAssignmentId)
					}
				/>
				<div className="visible-print-block">{item.Hours}</div>
			</div>
			<div className="col-xs-6 col-md-2 padding-top-15-sm">
				<strong className="card-only">Fees:&nbsp;</strong>
				<div>
					<span
						className={
							classNames(
								textClass,
								item.Fees.some(fee => fee._totalModified === true)
									? "fee-changed"
									: ""
							)
						}
					>
						{utils.currencyFormatter(item.FeeTotal)}
					</span>
					<button
						type="button"
						className="btn btn-link"
						onClick={() => toggleLineFees(item.JobAssignmentId)}
					>
						<i
							className={`rkf rkf-chevron-${lineFeeToggler[item.JobAssignmentId] ? "up" : "down"}`}
							aria-label="Toggle Line Item Fee"
						/>
					</button>
				</div>
				<If condition={!lineFeeToggler[item.JobAssignmentId]}>
					<button
						type="button"
						className={buttonPaddingLeft0Class}
						onClick={() => handleAddFeeClick(item.JobAssignmentId)}
						disabled={loadingInvoiceTotals}
					>
						+ Add Fee
					</button>
				</If>
			</div>
			<div className="col-xs-6 col-md-1 hidden-md text-right print-amount total-col">
				<strong className="card-only">Total:&nbsp;</strong>
				<strong className={textClass}>{utils.currencyFormatter(item.TotalAmount)}</strong>
			</div>
			<div className="col-md-1 visible-md text-right hidden-print">
				<strong className="hidden-md">Total:&nbsp;</strong>
				<strong className={textClass}>{utils.currencyFormatter(item.TotalAmount)}</strong>
			</div>
			<div
				className={`col-xs-12 line-fees${lineFeeToggler[item.JobAssignmentId] ? "" : " hidden"}`}
			>
				<For
					each="fee"
					of={item.Fees}
					index="index"
				>
					<div
						className="row"
						key={`${item.JobAssignmentId}-fee_${fee.Id || index}`}
					>
						<div
							className={`col-xs-6 col-md-offset-7 col-md-2 print-right ${fee._totalModified === true ? "fee-changed" : ""}`}
							title={fee.Name}
						>
							{fee.Name}
						</div>
						<div className="col-xs-6 col-sm-3 col-md-2 form-group div-fee-number-padding ">
							<button
								type="button"
								className="btn btn-link text-center delete-line-fee"
								onClick={() =>
									deletePositionFee(
										item.JobAssignmentId,
										fee.Id || index,
										!!fee.Id,
									)
								}
								disabled={loadingInvoiceTotals}
							>
								<img
									className="trash-icon"
									src={TrashIcon}
									width="20"
									height="20"
									alt="Remove Job"
									aria-label="Remove Job"
								/>
							</button>
							<input
								type="number"
								className={`form-control${fee.totalError ? " has-error" : ""}`}
								value={fee.Total}
								onChange={handlePositionFeeChange(
									item.JobAssignmentId,
									fee.Id || index,
									!!fee.Id,
								)}
								onBlur={() =>
									handlePositionFeeChangedOnBlur(
										item.JobAssignmentId,
										fee.Id || index,
										!!fee.Id,
									)
								}
								disabled={loadingInvoiceTotals}
							/>
							<div className="visible-print-block">
								{utils.currencyFormatter(fee.Total)}
							</div>
						</div>
					</div>
				</For>
				<div
					className={classNames("row new-line-fee hidden-print", {
						hidden: finalized || user.isSuperAdmin(),
					})}
				>
					<Choose>
						<When
							condition={newLineFeeToggler[item.JobAssignmentId]}
						>
							<div
								className={classNames(
									"col-md-2",
									newLineFeeToggler[item.JobAssignmentId]
										.feeType
										? "col-md-offset-3"
										: "col-md-offset-7",
								)}
							>
								<label
									htmlFor={`newLineFee-${item.JobAssignmentId}-feeType`}
								>
									<small>Type</small>
								</label>
								<select
									id={`newLineFee-${item.JobAssignmentId}-feeType`}
									name={`newLineFee-${item.JobAssignmentId}-feeType`}
									className="form-control"
									value={
										newLineFeeToggler[item.JobAssignmentId]
											.feeType
									}
									onChange={e =>
										handleNewFeeChange(
											item.JobAssignmentId,
											e,
										)
									}
								>
									<option value="">--</option>
									<For
										each="feeType"
										of={feeTypes.filter(ft => shouldIncludeMiscPersonnelFee(ft))}
									>
										<option
											key={`feeType-${item.JobAssignmentId}-${feeType.Id}`}
											value={feeType.Id}
										>
											{feeType.Name}
										</option>
									</For>
								</select>
							</div>
							<div
								className={classNames("col-md-2", {
									hidden:
										newLineFeeToggler[item.JobAssignmentId]
											.feeType === "",
								})}
							>
								<Choose>
									<When
										condition={
											newLineFeeToggler[
												item.JobAssignmentId
											].agencyFeeOptions.length &&
											newLineFeeToggler[
												item.JobAssignmentId
											].selectedFeeId !== ""
										}
									>
										<label
											htmlFor={`newLineFee-${item.JobAssignmentId}-selectedFeeId`}
										>
											<small>Select Fee</small>
										</label>
										<select
											id={`newLineFee-${item.JobAssignmentId}-selectedFeeId`}
											name={`newLineFee-${item.JobAssignmentId}-selectedFeeId`}
											className="form-control"
											value={
												newLineFeeToggler[
													item.JobAssignmentId
												].selectedFeeId
											}
											onChange={e =>
												handleNewFeeChange(
													item.JobAssignmentId,
													e,
												)
											}
										>
											<For
												each="agencyFee"
												of={
													newLineFeeToggler[
														item.JobAssignmentId
													].agencyFeeOptions
												}
											>
												<option
													key={`newLineFee-${item.JobAssignmentId}-${agencyFee.Id}`}
													value={agencyFee.Id}
												>
													{agencyFee.Description ||
														agencyFee.Name}
												</option>
											</For>
											<option value="">Custom Fee</option>
										</select>
									</When>
									<When
										condition={
											newLineFeeToggler[
												item.JobAssignmentId
											].selectedFeeId === ""
										}
									>
										<label
											htmlFor={`newLineFee-${item.JobAssignmentId}-feeName`}
										>
											<small>Name</small>
										</label>
										<div className="input-group">
											<input
												id={`newLineFee-${item.JobAssignmentId}-feeName`}
												name={`newLineFee-${item.JobAssignmentId}-feeName`}
												className="form-control"
												value={
													newLineFeeToggler[
														item.JobAssignmentId
													].feeName
												}
												onChange={e =>
													handleNewFeeChange(
														item.JobAssignmentId,
														e,
													)
												}
												onKeyPress={({ key }) => {
													if (key === "Enter")
														addNewLineFee(
															item.JobAssignmentId,
														);
												}}
												disabled={
													newLineFeeToggler[
														item.JobAssignmentId
													].feeType === "1"
												}
											/>
											<If
												condition={
													newLineFeeToggler[
														item.JobAssignmentId
													].agencyFeeOptions.length
												}
											>
												<span className="input-group-btn">
													<button
														type="button"
														className="btn btn-default"
														onClick={() =>
															clearNewLineFeeName(
																item.JobAssignmentId,
															)
														}
													>
														X
													</button>
												</span>
											</If>
										</div>
									</When>
								</Choose>
							</div>
							<div
								className={classNames("fee-rate col-md-2 div-fee-number-padding", {
									hidden:
										newLineFeeToggler[item.JobAssignmentId]
											.feeType === "",
								})}
							>
								<label
									htmlFor={`newLineFee-${item.JobAssignmentId}-feeRate`}
								>
									<small>Rate</small>
								</label>
								<br />
								<input
									type="number"
									inputMode="decimal"
									id={`newLineFee-${item.JobAssignmentId}-feeRate`}
									name={`newLineFee-${item.JobAssignmentId}-feeRate`}
									className="form-control rate-input"
									value={
										newLineFeeToggler[item.JobAssignmentId]
											.feeRate
									}
									onChange={e =>
										handleNewFeeChange(
											item.JobAssignmentId,
											e,
										)
									}
									onKeyPress={({ key }) => {
										if (key === "Enter")
											addNewLineFee(item.JobAssignmentId);
									}}
								/>
								<select
									name={`newLineFee-${item.JobAssignmentId}-calcType`}
									className="rate-type-input form-control"
									value={
										newLineFeeToggler[item.JobAssignmentId]
											.calcType
									}
									onChange={e =>
										handleNewFeeChange(
											item.JobAssignmentId,
											e,
										)
									}
									disabled={
										newLineFeeToggler[item.JobAssignmentId]
											.feeType === "1"
									}
								>
									<For
										each="calc"
										of={JURISDICTION_FEE_TYPES}
									>
										<option
											key={`calcType-${item.JobAssignmentId}-${calc.value}`}
											value={calc.value}
										>
											{calc.label}
										</option>
									</For>
								</select>
							</div>
							<div className="col-md-2">
								<br />
								<button
									type="button"
									id="add-new-fee"
									className={classNames("btn btn-link", {
										hidden:
											!newLineFeeToggler[
												item.JobAssignmentId
											].feeType ||
											!newLineFeeToggler[
												item.JobAssignmentId
											].feeName.trim() ||
											!newLineFeeToggler[
												item.JobAssignmentId
											].feeRate ||
											!newLineFeeToggler[
												item.JobAssignmentId
											].calcType,
									})}
									onClick={() =>
										addNewLineFee(item.JobAssignmentId)
									}
									disabled={loadingInvoiceTotals}
								>
									Add
								</button>
								<button
									type="button"
									className="btn btn-link"
									onClick={() =>
										toggleNewLineFee(item.JobAssignmentId)
									}
								>
									Cancel
								</button>
							</div>
						</When>
						<Otherwise>
							<div className="col-md-5 col-md-offset-5 text-right">
								<button
									type="button"
									className="btn btn-link padding-0"
									onClick={() =>
										toggleNewLineFee(item.JobAssignmentId)
									}
									disabled={loadingInvoiceTotals}
								>
									+ Add Fee
								</button>
							</div>
						</Otherwise>
					</Choose>
				</div>
			</div>
		</div>
	)
}

NonRKPayInvoiceItemForm.propTypes = {
	user: PropTypes.object,
	item: PropTypes.object,
	nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
	getDisputeReasonsByJobId: PropTypes.func.isRequired,
	officerMiscFeesV3: PropTypes.bool,
};

NonRKPayInvoiceItemForm.defaultProps = {
	user: {},
	item: {},
	officerMiscFeesV3: false,
};

export default NonRKPayInvoiceItemForm;
